import React, { useEffect } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Mousewheel, Autoplay, Pagination, Navigation } from 'swiper/modules';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { phone_number } from '../../config/details';
import { title } from '../../config/Config';
import { Diversity2Rounded, EmojiEvents, FormatQuoteRounded, Html, LocalGroceryStore, QueryStats, RocketLaunchRounded, SupervisedUserCircleRounded, ThumbUpOffAlt, TravelExploreRounded, VerifiedUserRounded } from '@mui/icons-material';
import aboutblb from '../../Assets/images/about-sec.png'
import banner_1 from '../../Assets/images/banner-1.svg'
import banner_2 from '../../Assets/images/banner-2.svg'
import banner_3 from '../../Assets/images/banner-3.svg'
import CountUp from 'react-countup';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import news_1 from '../../Assets/images/des.jpg';
import news_2 from '../../Assets/images/seo.jpg';
import user_1 from "../../Assets/images/user_1.jpeg";
import user_2 from "../../Assets/images/user_2.jpeg";
import user_3 from "../../Assets/images/user_3.jpeg";
import user_4 from "../../Assets/images/user_4.jpeg";
import user_5 from "../../Assets/images/user_5.png";
import user_6 from "../../Assets/images/user_6.png";
import user_7 from "../../Assets/images/user_7.jpeg";
import user_8 from "../../Assets/images/user_8.jpeg";




const Index = () => {
  

  const ServiceCard = [
    {
      LinkCard: '/web-design',
      IconCard: <Html />,
      headingCard: 'Website designing',
      pragraphCard: 'Web Designing in impressive way is not just a profession but passion for our Company...'
    },
    {
      LinkCard: '/webdeveloper',
      IconCard: <Html />,
      headingCard: 'Website development',
      pragraphCard: ' Gs Infotech Web Solutions designs and develops Web Applications that are business-critical...'
    },
    {
      LinkCard: '/wordpress',
      IconCard: <Html />,
      headingCard: 'wordpress website design',
      pragraphCard: ' Gs Infotech Web Solutions offers a rich repertoire of software services to its clients seeking...'
    },
    {
      LinkCard: '/search-engine',
      IconCard: <Html />,
      headingCard: 'search engine optimization',
      pragraphCard: ' Gs Infotech Web Solutions offering professional SEO Services In Chandigarh, Mohali Himachal...'
    },
    {
      LinkCard: '/webhosting',
      IconCard: <Html />,
      headingCard: 'web hosting',
      pragraphCard: ' Gs Infotech Web Solutions a web hosting company based out of Chandigarh, India. We are a....'
    },
    {
      LinkCard: '/email-hosting',
      IconCard: <Html />,
      headingCard: 'bulk sms & email hosting',
      pragraphCard: 'Bulk SMS Service is cheaper and more reliable service that allows you to communicate...'
    },
    {
      LinkCard: '/mobile-app',
      IconCard: <Html />,
      headingCard: 'Mobile Apps',
      pragraphCard: 'A seasoned React Native developer specializing in the creation of dynamic and cross-platform mobile applications for both Android and iOS platforms...'
    },

  ];


  useEffect(() => {
    const handleScroll = () => {
      // Get the fourth section
      const fourthSection = document.getElementById('news-q1');

      if (fourthSection) {
        const rect = fourthSection.getBoundingClientRect();

        if (rect.top <= window.innerHeight - 730) {
          document.body.classList.add('mode-activeted');

          if (rect.bottom <= window.innerHeight) {
            document.body.classList.remove('mode-activeted');
          }

        } 
        else {
          document.body.classList.remove('mode-activeted');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.body.classList.remove('mode-activeted');
    };
  }, []);


  return (
    <>

      {/* hero section start */}
      <div className='hero d-none'>
        <div className='hero-overly-left'></div>
        <div className='hero-overly-right'></div>
        <div className='hero-overly-img'></div>

        {/* start  */}
        <div className='container-layout'>
          <Swiper
            direction={'horizontal'}
            slidesPerView={1}
            spaceBetween={30}
            // mousewheel={true}
            pagination={{
              dynamicBullets: true,
            }}

            centeredSlides={true}
            // loop={true}
            // autoplay={{
            //   delay: 2500,
            //   disableOnInteraction: false,
            // }}
            navigation={true}
            modules={[Mousewheel, Autoplay, Pagination, Navigation]}
            className="mySwiper"
          >
            <SwiperSlide>
              <div className='slider-data'>
                <Row>
                  <Col lg={6}>
                    <div className='left-banner-data'>
                      <h5>SAFE / SECURE / PRIVATE </h5>
                      <h1> web development</h1>
                      <p>Develop client-emphasized and business-reliant interactive portals and websites using various web development strategies & platforms. </p>

                      <div className='btns-banner'>
                        <Link to={''} className='btn contact_btn'>Contact us</Link>
                        <Link to={'tel:' + phone_number} className='link-t Phone is-animating'></Link>
                      </div>
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className='right-banner-data development-div'>
                      {/* <img src={designweb} alt="Web Design"/> */}
                      <img className='development' src="https://kodesolution.com/2023/amiso/wp-content/uploads/2023/01/bg31-600x800.jpg" alt="Web Design" />
                    </div>
                  </Col>
                </Row>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className='slider-data'>
                <Row>
                  <Col lg={6}>
                    <div className='left-banner-data'>
                      <h5>creative / resposive / Clean code </h5>
                      <h1> Web Designing</h1>
                      <p>Create and retain your online presence with dazzling and unique website designs to instigate, engross, and deliver outcomes.</p>

                      <div className='btns-banner'>
                        <Link to={''} className='btn contact_btn'>Contact us</Link>

                        <Link to={'tel:' + phone_number} className='link-t Phone is-animating'>
                        </Link>
                      </div>
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className='right-banner-data'>
                      {/* <img src={designweb} alt="Web Design"/> */}
                      <img src="https://themexriver.com/wp/haptic/wp-content/uploads/2023/09/hero-9-img-1.png" alt="Web Design" />
                    </div>
                  </Col>
                </Row>
              </div>
            </SwiperSlide>


            <SwiperSlide>
              <div className='slider-data'>
                <Row>
                  <Col lg={6}>
                    <div className='left-banner-data'>
                      <h5>iOS / Android / SECURE </h5>
                      <h1> Mobile Apps</h1>
                      <p>A seasoned React Native developer specializing in the creation of dynamic and cross-platform mobile applications for both Android and iOS platforms.</p>

                      <div className='btns-banner'>
                        <Link to={''} className='btn contact_btn'>Contact us</Link>

                        <Link to={'tel:' + phone_number} className='link-t Phone is-animating'>
                        </Link>
                      </div>
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className='right-banner-data mobileapps'>
                      {/* <img src={designweb} alt="Web Design"/> */}
                      <img src="https://html.themexplosion.com/zumtech/assets/img/hero/hero-1.png" alt="Web Design" />
                    </div>
                  </Col>
                </Row>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>

      </div>


      <div className='banner-sec'>
        <div className='container-layout'>
          <div className='top-space'>
            <h1>Design Driven Development Your Web Products.</h1>

            <div className='row'>
              <div className='col-md-4'>
                <div className='banner-box'>
                  <img src={banner_1} alt='banner-1' />
                  <p>There are many variations variations of passages of Lorem Ipsum available.</p>
                </div>
              </div>

              <div className='col-md-4'>
                <div className='banner-box'>
                  <img src={banner_2} alt='banner-1' />
                  <p>There are many variations variations of passages of Lorem Ipsum available.</p>
                </div>
              </div>


              <div className='col-md-4'>
                <div className='banner-box'>
                  <img src={banner_3} alt='banner-1' />
                  <p>There are many variations variations of passages of Lorem Ipsum available.</p>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className='Social-media'>
          
        </div>
      </div>

      {/* WORKING PROCESS section */}

      <div className='start-to-end'>
        <div className='container-layout'>
          <div className='row'>

            <div className='col-12'>
              <div className='sec-heading'>
                <p className=''>WORKING PROCESS</p>
                <h1>Our Working Process - How We Work For Our Customers</h1>
              </div>
            </div>

            <div className='col-md-3 col-sm-6'>
              <div className='cus-card cus-card-border'>
                <h4 className='cus-heading'>1</h4>
                <h5>Discovery</h5>
                <p>The website project discovery phase that we take the time to get to know your business, your goals, and your target audience</p>
              </div>
            </div>

            <div className='col-md-3 col-sm-6'>
              <div className='cus-card cus-card-border  cus-card-border2'>
                <h4 className='cus-heading'>2</h4>
                <h5>Planning</h5>
                <p>A well-crafted website project plan can help to ensure that the project stays on track, meets its budget, and delivers the desired results.</p>
              </div>
            </div>

            <div className='col-md-3 col-sm-6'>
              <div className='cus-card cus-card-border'>
                <h4 className='cus-heading'>3</h4>
                <h5>Development</h5>
                <p>Website project development is the process of creating a website from start to finish.</p>
              </div>
            </div>

            <div className='col-md-3 col-sm-6'>
              <div className='cus-card cus-card-border'>
                <h4 className='cus-heading'>4</h4>
                <h5>Product Handover</h5>
                <p>A successful website product handover is essential for ensuring that your client is happy with the final product and that it meets their needs.</p>
              </div>
            </div>
          </div>

        </div>

      </div>


      {/* abouts section */}

      <div className='home-about'>
        <div className='container-layout'>
          <div className='row'>
            <div className='col-lg-6'>
              <div className='home-left-about'>
                <p className='abouttxt'>About Us {title}</p>
                <h1>We made things easier for your business</h1>
                <h6 className='mb-4'>  “An excellent platform for web designing and web development in India with result-driven strategies to boost ROI.”</h6>
                <p className='pragraph-sc'>As it is the world of dot com, every business owner thinks of having its company presence on the huge World Wide Web. This is where the role of website designing , Apps development and web development services comes in and we, at {title}, have professional and skilled designers and developers to help you get the kind of website of any type you want for your online existence and reputation with quality.</p>



                <div className='icons-group'>
                  <div className='icons-sec'>
                    <div className='icons'> <QueryStats /> </div>
                    <p>BUSINESSES <br /> GROWTH</p>
                  </div>

                  <div className='icons-sec'>
                    <div className='icons'> <ThumbUpOffAlt /> </div>
                    <p>MARKETING <br />SOLUTION</p>
                  </div>

                </div>

                <Link to="/about" className='btn contact_btn mt-3'> About us </Link>

              </div>
            </div>

            <div className='col-lg-6'>
              <div className='home-right-about'>
                <div className='img-about-sc'>
                  <img src={aboutblb} alt='aboout-img' />
                </div>

                <div className='home-ryt-sec'>
                  <h1><EmojiEvents /></h1>
                  <h5>Top Quality Web <br />Solutions</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* services sections */}

      <section className='services-sec'>
        <div className='container-layout'>
          <div className='row'>

            <div className='col-12'>
              <div className='sec-heading'>
                <p className=''>Best Service</p>
                <h1>OUR BEST SERVICE</h1>
                <h6>We have a wide range of services to offer in our bag. Our services are customer-centric and result- oriented. With the varied range of services and purposeful solutions, we endeavor to nurture and evolve your ideas into custom, premium, well-designed and developed distinctive websites that will go beyond your imagination and turn your dreams into reality. Check out our range of services, which we assure to  offer with quality and successful results:</h6>
              </div>
            </div>

            <div className='col-lg-4'>
              <div className='first-card card-1'>
                <h3>Powerful features</h3>
                <p>Aliquam hendrerit ligula eu lobortis maximus. Praesent elementum rhoncus convallis.</p>

              </div>
            </div>


            {ServiceCard.map((item :any, index:any) => (
              <div className='col-lg-4 mb-4' key={index}>
                <div className='card'>
                  <div className='icons-txt'>
                    {item.IconCard}
                  </div>

                  <h3>{item.headingCard} </h3>
                  <p>{item.pragraphCard} </p>

                  <Link to={item.LinkCard} className='stretched-link'> <LocalGroceryStore /> Learn More</Link>
                </div>
              </div>
            ))}


            <div className='col-lg-4'>
              <div className='first-card card-1'>
                <h3>Business Stratagy</h3>
                <p>There are many variations of passages of Lorem Ipsum available, but the majority.</p>

              </div>
            </div>
          </div>
        </div>
      </section>



      <section className='choose-us'>
        <div className='container-layout'>
          <div className='row'>

            <div className='col-12'>
              <div className='sec-heading'>
                <p className=''>Why Choose Us</p>
                <h1>Our Company Growth</h1>
                <h6>{title} is a company well-versed with the web and mobile application solutions and provides end-to-end solution to meet your business needs and deeds. We can empower your business to boost your conversion rates and revenues.</h6>
              </div>
            </div>

            <div className='col-sm-4 col-xl-2'>
              <div className='card choous-card'>
                <h4 className='choose-heading'><TravelExploreRounded /></h4>
                <p>Countries Served</p>
                <h1><CountUp delay={1} end={100} />+ </h1>
              </div>
            </div>

            <div className='col-sm-4 col-xl-2'>
              <div className='card choous-card'>
                <h4 className='choose-heading'><RocketLaunchRounded /></h4>
                <p>Project Delivered</p>
                <h1><CountUp delay={1} end={2000} decimal="" />+</h1>
              </div>
            </div>
            <div className='col-sm-4 col-xl-2'>
              <div className='card choous-card'>
                <h4 className='choose-heading'><VerifiedUserRounded /></h4>
                <p>Satisfaction rate</p>
                <h1><CountUp delay={1} end={100} decimal="" />%</h1>
              </div>
            </div>
            <div className='col-sm-4 col-xl-2'>
              <div className='card choous-card'>
                <h4 className='choose-heading'><SupervisedUserCircleRounded /></h4>
                <p>Clients</p>
                <h1><CountUp delay={1} end={1200} decimal="" />+</h1>
              </div>
            </div>
            <div className='col-sm-4 col-xl-2'>
              <div className='card choous-card'>
                <h4 className='choose-heading'><Diversity2Rounded /></h4>
                <p>Team {/* of Professionals */}</p>
                <h1><CountUp delay={1} end={50} decimal="" />+</h1>
              </div>
            </div>
            <div className='col-sm-4 col-xl-2'>
              <div className='card choous-card'>
                <h4 className='choose-heading'><SupervisedUserCircleRounded /></h4>
                <p>On the market</p>
                <h1><CountUp delay={1} end={12} decimal="" /> Year</h1>
              </div>
            </div>

            <div className='col-12'>
              <div className='row'>
                <div className='card-left-choose'>
                  <h4> Why We Are #1 In The Industry?</h4>
                  <p>A team of {title} has become a top-rated and expert company in Abohar. We use the latest technology, methodology, and approach to design, develop, and optimize the websites regardless of the business type. We ideally work in CMS (WordPress) and other web designing, web development, and SEO techniques. If you want to build a new website or make some changes in the current website, then we are here to support you and give you a full-fledged website that runs on multiple devices without any fail. </p>
                  <p>We have a detailed and unique strategy to work and offer our range of services. We use our knowledge and capability to assess requirements and expectations of our clients, perform designing or redesigning the website, monitoring and optimizing the content, testing the codes, maintaining websites to stay up-to-date, and creating digital approach. We have:</p>
                  <ul>
                    <li> - Endless design concepts </li>
                    <li>- Proficient designers and developers  </li>
                    <li>- Teamwork</li>
                    <li>- Fastest turnaround time </li>
                    <li>- Assured customer satisfaction </li>
                    <li>- Quality and timely project submission </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>


      <section className='clinet-sec'>
        <div className='container-layout'>
          <Tabs>
            <div className='row'>

              <div className='col-12'>
                <div className='sec-heading'>
                  <p className=''>Client Say</p>
                  <h1>Our Happy clients</h1>
                  <h6> Undoubtedly, our customers are very prominent for us and we always try to give the kind of quality they are seeking. We have hundreds of contented clients from different parts of India and overseas as well. Know them</h6>
                </div>
              </div>

              <div className='col-md-7'>
                <div className='tab-data'>
                  <TabPanel>
                    <div className='tab-inner-data'>
                      <span className='qutos-top'><FormatQuoteRounded /></span>
                      <h2>Our best-in-class WordPress solution with additio nal optiz ation to make an running a WooCommerce</h2>
                      <h6><span>JOHN NIRA</span> - COO, AMERIMAR ENTERPRISES, INC.</h6>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div className='tab-inner-data'>
                      <span className='qutos-top'><FormatQuoteRounded /></span>
                      <h2>John The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections Bonorum et Malorum original.</h2>
                      <h6><span>JOHN NIRA</span> - COO, AMERIMAR ENTERPRISES, INC.</h6>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div className='tab-inner-data'>
                      <span className='qutos-top'><FormatQuoteRounded /></span>
                      <h2>Janin Ara The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections Bonorum et Malorum original.</h2>
                      <h6><span>Janin Ara</span> - COO, AMERIMAR ENTERPRISES, INC.</h6>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div className='tab-inner-data'>
                      <span className='qutos-top'><FormatQuoteRounded /></span>
                      <h2>John The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections Bonorum et Malorum original.</h2>
                      <h6><span>JOHN NIRA</span> - COO, AMERIMAR ENTERPRISES, INC.</h6>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div className='tab-inner-data'>
                      <span className='qutos-top'><FormatQuoteRounded /></span>
                      <h2>Janin Ara The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections Bonorum et Malorum original.</h2>
                      <h6><span>Janin Ara</span> - COO, AMERIMAR ENTERPRISES, INC.</h6>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div className='tab-inner-data'>
                      <span className='qutos-top'><FormatQuoteRounded /></span>
                      <h2>John The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections Bonorum et Malorum original.</h2>
                      <h6><span>JOHN NIRA</span> - COO, AMERIMAR ENTERPRISES, INC.</h6>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div className='tab-inner-data'>
                      <span className='qutos-top'><FormatQuoteRounded /></span>
                      <h2>Janin Ara The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections Bonorum et Malorum original.</h2>
                      <h6><span>Janin Ara</span> - COO, AMERIMAR ENTERPRISES, INC.</h6>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div className='tab-inner-data'>
                      <span className='qutos-top'><FormatQuoteRounded /></span>
                      <h2>John The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections Bonorum et Malorum original.</h2>
                      <h6><span>JOHN NIRA</span> - COO, AMERIMAR ENTERPRISES, INC.</h6>
                    </div>
                  </TabPanel>
                </div>
              </div>

              <div className='col-md-5'>
                <div className='tab-list'>
                  <TabList>
                    <Tab><img src={user_1} alt="img-user" /> </Tab>
                    <Tab><img src={user_2} alt="img-user" /> </Tab>
                    <Tab><img src={user_3} alt="img-user" /> </Tab>
                    <Tab><img src={user_4} alt="img-user" /> </Tab>
                    <Tab><img src={user_5} alt="img-user" /> </Tab>
                    <Tab><img src={user_6} alt="img-user" /> </Tab>
                    <Tab><img src={user_7} alt="img-user" /> </Tab>
                    <Tab><img src={user_8} alt="img-user" /> </Tab>
                  </TabList>
                </div>
              </div>



            </div>
          </Tabs>
        </div>
      </section>


      <div className='' id='news-q1'>

        <section className='news-sec' >
          <div className='container-layout'>
            <div className='row'>

              <div className='col-12'>
                <div className='sec-heading'>
                  <p className=''>what's stories on</p>
                  <h1>Latest News / Info</h1>
                  <h6> There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</h6>
                </div>
              </div>

              <div className='col-md-6 col-lg-4'>
                <div className='card card-news'>
                  <div className='card-thumnail'>
                    <img src={news_1} alt='news-1' />
                  </div>

                  <div className='card-txt'>
                    <div className='card-txt-heading'>
                      <h6>Web Development</h6>
                      <h2>Web Development Company: Things To Keep In Concentration! <br /> <span>December 6, 2019</span> </h2>
                      <Link className='btn stretched-link' to="/webdeveloper">Read More</Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-md-6 col-lg-4'>
                <div className='card card-news'>
                  <div className='card-thumnail'>
                    <img src={news_2} alt='news-1' />
                  </div>

                  <div className='card-txt'>
                    <div className='card-txt-heading'>
                      <h6>SEO</h6>
                      <h2>Five SEO Tips For A WordPress Website <br /> <span>December 6, 2019</span> </h2>
                      <Link className='btn stretched-link' to="/search-engine">Read More</Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-md-6 col-lg-4'>
                <div className='card card-news'>
                  <div className='card-thumnail'>
                    <img src={news_1} alt='news-1' />
                  </div>

                  <div className='card-txt'>
                    <div className='card-txt-heading'>
                      <h6>Web Design</h6>
                      <h2>Web Development: A Way To Improve Your Creativity Via Web Design <br /> <span>December 6, 2019</span> </h2>
                      <Link className='btn stretched-link' to="/web-design">Read More</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>




        <section className='contant-botom-sec'>
          <div className='container-layout'>
            <div className='card'>
              <div className='card-inner'>
                <h3>Ready to Shape the Future of WordPress with Us?</h3>
                <p>Partnering with us means collaborating with a highly amicable team that is more than obliged to answer all your queries. Get in touch with us to know what would be the best-fit solutions for you</p>
                <Link to="/contact" className='btn'> Contact us</Link>
              </div>
            </div>
          </div>
        </section>
      </div>


    </>
  )
}

export default Index